export enum NodeRunStatus {
  NotRun = 1,
  Idle,
  Waiting,
  Next,
  Processing,
  Completed,
  Warning,
  Error,
  PipelineModified,
  NotConfigured
}

export enum DataFarmatype {
  Subtask = 1,
  Task,
  Activity,
  Case,
  User,
  Behavior,
  Master
}

export class NodeRunStatusUtil {

  public static toString(dataType: NodeRunStatus): string {
    let value = 'Idle';

    switch (dataType) {
      case NodeRunStatus.NotRun:
        value = 'Not Run';
        break;
      case NodeRunStatus.Idle:
        value = 'Idle';
        break;
      case NodeRunStatus.Waiting:
        value = 'Waiting';
        break;
        case NodeRunStatus.Next:
        value = 'Next';
        break;
      case NodeRunStatus.Processing:
        value = 'Processing';
        break;
      case NodeRunStatus.Completed:
        value = 'Completed';
        break;
      case NodeRunStatus.Warning:
        value = 'Warning';
        break;
      case NodeRunStatus.Error:
        value = 'Error';
        break;
      case NodeRunStatus.PipelineModified:
        value = 'Pipeline Modified';
        break;
      case NodeRunStatus.NotConfigured:
        value = 'Not Configured';
        break;
    }

    return value;
  }

  public static statusColor(dataType: NodeRunStatus): string {
    let value = '#A6A6A6';//#FFFFFF';

    switch (dataType) {
      case NodeRunStatus.NotRun:
        value = '#FFFFB0';
        break;
      case NodeRunStatus.Idle:
        value = '#A6A6A6';//#FFFFFF';
        break;
      case NodeRunStatus.Waiting:
        value = '#00BBFF';
        break;
        case NodeRunStatus.Next:
        value = '#FFFF00';
        break;
      case NodeRunStatus.Processing:
        value = '#F289F5';
        break;
      case NodeRunStatus.Completed:
        value = '#00FF00';
        break;
      case NodeRunStatus.Warning:
        value = '#FFFF00';
        break;
      case NodeRunStatus.Error:
        value = '#FF0000';
        break;
      case NodeRunStatus.PipelineModified:
        value = '#FA8846';
        break;
      default: 
        value = '#FFFFFF';
        break;
    }

    return value;
  }
}

export class NodeFarmtypeUtil {

  public static toFarmtypeColor(dataType: DataFarmatype): string {
    let value = '#FFFFFF';

    switch (dataType) {
      case DataFarmatype.Subtask:
        value = '#00B050';
        break;
      case DataFarmatype.Task:
        value = '#FFC000';
        break;
      case DataFarmatype.Activity:
        value = '#00B0F0';
        break;
        case DataFarmatype.Case:
        value = '#FF0000';
        break;
      case DataFarmatype.User:
        value = '#0066FF';
        break;
      case DataFarmatype.Behavior:
        value = '#00FFCC';
        break;
      case DataFarmatype.Master:
        value = '#DDDDDD';
        break;
    }

    return value;
  }

  public static toFarmtypeName(dataType: DataFarmatype): string {
    let value = '';

    switch (dataType) {
      case DataFarmatype.Subtask:
        value = 'Subtask';
        break;
      case DataFarmatype.Task:
        value = 'Task';
        break;
      case DataFarmatype.Activity:
        value = 'Activity';
        break;
        case DataFarmatype.Case:
        value = 'Case';
        break;
      case DataFarmatype.User:
        value = 'User';
        break;
      case DataFarmatype.Behavior:
        value = 'Behavior';
        break;
      case DataFarmatype.Master:
        value = 'Master';
        break;
    }

    return value;
  }
}

